<script>
	import Grid from './components/Grid.svelte';
	import {colors, enemies, player, gridSize} from './store';
	import Enemy from './components/Enemy.svelte';
	import Player from './components/Player.svelte';
	import Lasers from './components/Lasers.svelte';
	import Commands from './components/Commands.svelte';
	import GlobalSymbols from './components/GlobalSymbols.svelte';
	import AvailableCommands from './components/AvailableCommands.svelte';

	// Update. As often as possible
	let lastUpdate = 0;
	const update = timestamp => {
		let delta = (timestamp - lastUpdate) / 16;
		$player = $player.update(delta);
		$enemies = $enemies.map(robot => robot.update(delta));
		lastUpdate = timestamp;
		window.requestAnimationFrame(update);
    }
	window.requestAnimationFrame(update);

	// Fixed Update. ~60 times per second
	setInterval(() => {
		[$player, ...$enemies].forEach(robot => robot.fixedUpdate());
	}, 16);
</script>

<span class="text-white fixed bg-blue-500 w-full text-center">
	<!-- x: {$player.position.x} y: {$player.position.y} transform.x: {$player.transform.x} transform.y: {$player.transform.y} -->
</span>
<main class="h-screen w-screen bg-gray-900 flex flex-col justify-center content-center">
	<svg class="w-full overflow-visible bg-gray-900 h-1/2 p-2" xmlns="http://www.w3.org/2000/svg" viewBox="-.5 -.5 {gridSize} {gridSize}">
		<GlobalSymbols />
		<Grid />
		<Lasers />
		<Player x="{$player.animatedPosition.x}" y="{$player.animatedPosition.y}" />
		{#each $enemies as {animatedPosition, animatedDirection, markings}, i}
   			 <Enemy {...{animatedPosition, animatedDirection, markings}} />
		{/each}
	</svg>
	<div class="h-1/2 flex flex-col justify-center content-center">
		<div class="h-3/5 bg-blue-500">
			<Commands />
		</div>
		<div class="h-2/5">
			<AvailableCommands />
		</div>
	</div>
	<!-- <svg class="w-full overflow-visible bg-gray-800 h-full flex-1 shadow-outline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" preserveAspectRatio="xMidYMax meet">
		<Commands />
		<AvailableCommands y="{12.6}" />
	</svg> -->
</main>
